import {formatPrice,formatPriceRev,checkAusbildung,zeitmodell} from './logic';

/**
 * Summenbildung
 * @param $this
 * @param zwischenloeschen
 * @param abzugloeschen
 * @param summe
 */
export default function getSum($this, zwischenloeschen = false, abzugloeschen = false, summe = false){
    //console.log('löschen? '+zwischenloeschen)
    if(zwischenloeschen||abzugloeschen||summe) {
        if(checkAusbildung($this)==='meister'&&!zeitmodell($this)){ // wenn Löschen, aber Meisterbafög und Teilzeit
            // Abzüge löschen
            abzugloeschen?
                $this.el$('results.abzug').value = formatPrice(
                    0 ) : ''
            // Zwischensumme berechnen
            zwischensumme($this)

            // Ergebnis berechnen
            ergebnis($this)
        }else { // alles löschen
            zwischenloeschen ?
                $this.el$('results.zwischen').value = formatPrice(
                    0
                ) : ''

            abzugloeschen ?
                $this.el$('results.abzug').value = formatPrice(
                    0
                ) : ''

            summe ?
                $this.el$('results.ergebnis').value = formatPrice(
                    0
                ) : ''
        }
    }else{
        // Zwischensumme berechnen
        zwischensumme($this)
        // Abzüge berechnen
        abzuege($this)
        // Ergebnis berechnen
        ergebnis($this)
    }
    //console.log('zwischensumme: '+$this.el$('results.zwischen').value)
}

/**
 * Zwischensumme bilden
 * @param $this
 */
function zwischensumme($this){
    let zwischen = 0.00
    if($this.el$('results.anspruch').value){
        zwischen += formatPriceRev($this.el$('results.anspruch').value)
    }
    if($this.el$('results.wohnzuschlag').value){
        zwischen += formatPriceRev($this.el$('results.wohnzuschlag').value)
    }
    if($this.el$('results.krankenkassenzuschlag').value){
        zwischen += formatPriceRev($this.el$('results.krankenkassenzuschlag').value)
    }
    if($this.el$('results.kinderzuschlag').value){
        zwischen += formatPriceRev($this.el$('results.kinderzuschlag').value)
    }
    if($this.el$('results.meisterzuschlag').value){
        zwischen += formatPriceRev($this.el$('results.meisterzuschlag').value)
    }
    if($this.el$('results.lehrgangszuschlag').value){
        zwischen += formatPriceRev($this.el$('results.lehrgangszuschlag').value)
    }
    $this.el$('results.zwischen').value = formatPrice(
        zwischen
    )
}

/**
 * Abzüge vom BAföG - Summe bilden
 * @param $this
 */
function abzuege($this){
    let abzuege = 0.00
    if($this.el$('results.einkommen').value){
        abzuege += formatPriceRev($this.el$('results.einkommen').value)
    }
    if($this.el$('results.vermoegen').value){
        abzuege += formatPriceRev($this.el$('results.vermoegen').value)
    }
    if($this.el$('results.schulden').value){
        abzuege -= formatPriceRev($this.el$('results.schulden').value)
    }
    if($this.el$('results.eltern').value){
        abzuege += formatPriceRev($this.el$('results.eltern').value)
    }
    if(abzuege<0){ // wenn Abzüge ins negative gehen, also zur Erhöhung des BAföG's führen -> nullen
        //console.log('Abzug unter 0: '+abzuege)
        abzuege = 0
    }
    $this.el$('results.abzug').value = formatPrice(
        -abzuege
    )
}

/**
 * Ergebnis aus Anspruch und Abzüge bilden
 * @param $this
 */
function ergebnis($this){
    let ergebnis = 0.00
    if($this.el$('results.zwischen').value){
        ergebnis += formatPriceRev($this.el$('results.zwischen').value)
    }
    if($this.el$('results.abzug').value){
        ergebnis += formatPriceRev($this.el$('results.abzug').value)
    }
    if(ergebnis>0){
        $this.el$('results.ergebnis').value = formatPrice(
            ergebnis
        )
    }else{
        $this.el$('results.ergebnis').value = formatPrice(
            0
        )
    }
    if($this.wizard$.current$.$el.nextElementSibling.innerText==='Voraussichtliche Förderhöhe'){
        let sample = document.getElementById("antrag-jetzt");
        sample.style.visibility = 'visible';
    }else{
        let sample = document.getElementById("antrag-jetzt");
        sample.style.visibility = 'hidden';
    }
}
